var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFinalise({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3916 14.7708H17.4834V29.5415H23.3916V14.7708Z",
    fill: "#4D2481"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2081 14.7708H32.2539V29.5415H35.2081V14.7708Z",
    fill: "#4D2481"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1163 14.7708H38.1621V29.5415H41.1163V14.7708Z",
    fill: "#4D2481"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5294 14.7708H11.5752V29.5415H14.5294V14.7708Z",
    fill: "#4D2481"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2999 14.7708H26.3457V29.5415H29.2999V14.7708Z",
    fill: "#4D2481"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3642 0H18.9604C18.1446 0 17.4834 0.661335 17.4834 1.47702V5.90823H20.4376V2.95418H55.8873V51.5941L51.0277 47.7093C50.7514 47.4274 50.3737 47.2678 49.979 47.2662V50.826L50.0971 50.7078L56.3156 55.6855C56.8901 56.2647 57.8252 56.2685 58.4044 55.6941C58.6826 55.4183 58.8397 55.0433 58.8414 54.6516V1.47702C58.8414 0.661335 58.18 0 57.3642 0Z",
    fill: "#4D2481"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M45.548 8.8623H7.14404C6.32823 8.8623 5.66702 9.52364 5.66702 10.3393V63.5139C5.66232 64.3297 6.31972 64.9947 7.13541 64.9995C7.53221 65.0018 7.91327 64.8444 8.19278 64.5626L14.4112 59.5848L19.389 64.5626C19.9652 65.1353 20.8956 65.1353 21.4717 64.5626L26.346 59.6883L31.2056 64.5479C31.7818 65.1206 32.7122 65.1206 33.2882 64.5479L38.266 59.5701L44.4845 64.5479C45.0506 65.1352 45.9856 65.1525 46.573 64.5863C46.864 64.3058 47.0274 63.9182 47.025 63.5139V10.3395C47.025 9.52364 46.3636 8.8623 45.548 8.8623ZM44.0708 60.4564L39.2112 56.5716C38.635 55.9989 37.7046 55.9989 37.1286 56.5716L32.2542 61.4312L27.3946 56.5716C26.8185 55.9989 25.888 55.9989 25.312 56.5716L20.4376 61.4312L15.578 56.5569C15.0019 55.9842 14.0714 55.9842 13.4954 56.5569L8.62107 60.4564V11.8165H44.0708V60.4564Z",
    fill: "#4D2481"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3459 35.4497H11.5752V38.4039H26.3459V35.4497Z",
    fill: "#4D2481"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1166 41.3579H11.5752V44.3121H41.1166V41.3579Z",
    fill: "#4D2481"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2542 47.2664H11.5752V50.2205H32.2542V47.2664Z",
    fill: "#4D2481"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinalise);
export default __webpack_public_path__ + "static/media/finalise.cbc8d56b8b6a367671ea0a43558d498c.svg";
export { ForwardRef as ReactComponent };